import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {provideNativeDateAdapter} from '@angular/material/core';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {PreordersManagementService} from "../services/preorders-management.service";
import {DatePipe} from '@angular/common';
import {MatButtonModule} from '@angular/material/button';
import {MatSnackBar} from '@angular/material/snack-bar';
import {NgxMatDatepickerInput, NgxMatDatetimepicker} from '@ngxmc/datetime-picker';
import {MatIconModule} from "@angular/material/icon";


@Component({
  selector: 'app-preorders-delieveries',
  imports: [
    ReactiveFormsModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    NgxMatDatepickerInput,
    NgxMatDatetimepicker
  ],
  providers: [provideNativeDateAdapter()],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './preorders-deliveries.component.html',
  styleUrl: './preorders-deliveries.component.scss'
})

export class PreordersDeliveriesComponent {
  private preordersManagementService = inject(PreordersManagementService)
  private formBuilder = inject(FormBuilder);
  private snackBar = inject(MatSnackBar)
  deliveryForm!: FormGroup;
  filename: any[] = [];
  categories: any[] = [];
  periods: any[] = [];

  private initializeForm() {
    this.deliveryForm = this.formBuilder.group({
      start: ['', Validators.required],
      category: ['', Validators.required],
      period: ['', Validators.required],
      file: ['', Validators.required],
    });
  }

  ngOnInit() {
    this.initializeForm();

    this.preordersManagementService.getCategory().subscribe((res: any) => {
      this.categories = res.return_object;
    });
  }

  public setPeriods(event: any) {
    const url = event.value;

    const category = this.categories.find(cat => cat.url === url);
    this.periods = category.periods;
  }

  onFileDropped(event: any) {
    const files = event;
    this.sendFile(files)
  }

  onFileUploaded(event: any) {
    const files = event.target.files;
    this.sendFile(files)
  }

  sendFile(files: any) {
    const file = files[0];
    this.filename = files;
    this.deliveryForm.patchValue({file: file});
  }

  submit() {
    const data = this.deliveryForm.value;
    const datePipe = new DatePipe('de-DE');
    const formattedDate = datePipe.transform(data.start, 'yyyy-MM-ddTHH:mm:ss') ?? '';

    let formData = new FormData();
    formData.append('file', data.file);
    formData.append('dateTime', formattedDate);
    formData.append('category', data.category);
    formData.append('period', data.period);
    this.preordersManagementService.upload(formData).subscribe((res: any) => {
      if (res.error_code === null) {
        this.snackBar.open(this.filename + ' wurde hochladen', 'X', {
          duration: 2000,
          panelClass: ['snackbar-success'],
          horizontalPosition: 'center',
          verticalPosition: 'top',
        });
      } else {
        this.snackBar.open(`Fehler: ${res.error_code}`, 'X', {
          duration: 2000,
          panelClass: ['snackbar-error']
        });
      }
    })
  }

  isFormValid() {
    return this.deliveryForm?.valid ?? false;
  }

  preventTyping(event: KeyboardEvent) {
    event.preventDefault();
  }

  onDateTimeChange(event: any) {
    setTimeout(() => {
      const inputElement = document.querySelector('input[formControlName="start"]') as HTMLInputElement;
      if (inputElement && this.deliveryForm.get('start')?.value) {
        const date = this.deliveryForm.get('start')?.value;
        const datePipe = new DatePipe('de-DE');
        inputElement.value = datePipe.transform(this.deliveryForm.get('start')?.value, 'dd.MM.yyyy HH:mm') ?? '';
      }
    }, 100);
  }
}
